import { Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierQualification extends Layout {
    panelMain: Panel;
    panelResults: Panel;
    textboxProfile: Textbox;
}
